<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d-flex align-items--center direction--column">
        <dara-icon size="xxl" icon="folder-x" />
        <dara-header>{{ $t('you-dont-have-permission-to-edit-departments') }}</dara-header>
        <dara-p>
          {{ $t('you-dont-have-the-right-permission') }}
        </dara-p>
        <br>
        <dara-button theme="primary" @click="goToBasePage()">
          {{ $t('return-to-page') }}
        </dara-button>
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToBasePage } from '@/router/route.service';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraArticleForbiddenPage',
  components: {
    DaraSingleContentLayout,
  },
  methods: {
    goToBasePage,
  },
};
</script>
